import React from 'react';

import  Box  from '@mui/material/Box';
import  Button  from '@mui/material/Button';
import  Typography  from '@mui/material/Typography';

import AddIcon from '@mui/icons-material/Add';

const CustomButton = ({ title = "",onNavigate ,disabled,loading,props}) => {
  return (
    <Button
      disabled={disabled}
      onClick={onNavigate}
      loading={loading}
      type="submit"

      sx={{
        mb:{xs:"16px",md:"0px"},
        flexShrink:1,
        backgroundColor: '#D6B981',
        borderRadius: '8px',
        color: 'black',
        fontSize: '14px',
        height: '46px',
        px: '10px',
        pl: 0,
        '&:hover': {
          backgroundColor: '#c4a96f'
        }
      }}
      startIcon={
        <Box
          sx={{
            backgroundColor: '#c0a467',
            height:"100%",
            py:1.3,
            px:1,
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <AddIcon sx={{ color: 'white' }} />
        </Box>
      }
    >
      <Typography sx={{
        fontSize:{md:"16px",xs:"12px"},
        textTransform: "none"
      }} >
      {title}
      </Typography> 
      {props}
    </Button>
  );
};

export default CustomButton;
